import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from "@auth0/auth0-react";
import Auth0DebugTokenExposer from './Components/Commons/Auth0DebugTokenExposer';

const domain = process.env.REACT_APP_AUTH0_DOMAIN ?? "";
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID ?? "";
// OJO: el audience de la API (REACT_APP_AUTH0_AUDIENCE) NO va aca. Si se pide en este
// authorizationParams de nivel Provider, se manda tambien en el /authorize inicial del login,
// y si el client todavia no esta autorizado para esa API en el dashboard de Auth0
// (Applications > APIs > tu API > Machine to Machine Applications), Auth0 rechaza el /authorize
// COMPLETO y el login queda en loop -- paso exactamente eso. El audience se pide aparte, solo
// para los tokens de la API, en buildAuthorizationHeader (Components/Commons/AuthHeaders.js),
// que ya esta protegido con try/catch para que un problema ahi nunca bloquee el login en si.

createRoot(document.getElementById('root')).render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    authorizationParams={{
      redirect_uri: window.location.origin,
    }}
  >
    <React.StrictMode>
      <Auth0DebugTokenExposer />
      <App />
    </React.StrictMode>
  </Auth0Provider>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
